export default {
  "brand": "USFans Spreadsheet",
  "nav.spreadsheet": "Feuille de calcul",
  "nav.guides": "Guides",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.comparisons": "Comparaisons",
  "nav.safety": "Sécurité",
  "nav.categories": "Catégories",
  "nav.resources": "Ressources",
  "nav.home": "Accueil",
  "nav.buyingGuide": "Guide d'achat",
  "lang.label": "Langue",
  "cta.explore": "Explorer USFans Spreadsheet",
  "cta.buyNow": "Acheter maintenant",
  "cta.viewAll": "Voir tous les guides",
  "cta.readMore": "Lire le guide",
  "cta.visitStore": "Visiter la boutique",
  "article.notFound": "Article introuvable",
  "article.backHome": "Retour à l'accueil",
  "article.faqTitle": "Questions fréquentes",
  "article.relatedTitle": "Guides associés",
  "article.ctaTitle": "Poursuivez vos recherches",
  "article.ctaText": "Explorez plus de guides ou visitez la boutique pour mettre vos recherches à profit.",
  "footer.about": "Un centre de ressources indépendant pour rechercher USFans Spreadsheet, ses guides, comparaisons, informations de livraison et conseils de sécurité.",
  "footer.guides": "Guides",
  "footer.company": "Entreprise",
  "footer.resources": "Ressources",
  "footer.legal": "Mentions légales",
  "footer.rights": "Tous droits réservés.",
  "footer.disclaimer": "Ce site web est une ressource informative indépendante. Les informations peuvent évoluer au fil du temps. Vérifiez toujours les détails importants avant de faire des achats ou de partager des informations personnelles."
};